import React from 'react'
import PropTypes from 'prop-types'
import HeadingBeta from '../headings/heading-beta'
import ModalWrapper from '../modal/modal-wrapper'
import Subtitle from '../texts/subtitle'
import ConfirmationMsg from '../messages/confirmation-msg'
import Icon from '../icons/icon'
import FlatButton from '../buttons/flat-button'
import MsgIntro from '../messages/msg-intro'

const AlertFinishedOutbid = props => (
  <ModalWrapper onClose={props.onClose}>
    <ConfirmationMsg>
      <div className='center'>
        <MsgIntro outbid>
          <HeadingBeta outbid center>
            Sorry {props.userName},
          </HeadingBeta>
          <Icon name='sorry' />
        </MsgIntro>
        <Subtitle>{`${props.auctionTitle} just finished…`}</Subtitle>
        <Subtitle>
          And you’ve been outbid for{' '}
          <strong>{props.lostItemCount} items</strong>
        </Subtitle>
        <div className='full-width'>
          <FlatButton text='close' onClick={props.onClose} />
        </div>
      </div>
    </ConfirmationMsg>
  </ModalWrapper>
)

AlertFinishedOutbid.propTypes = {
  onClose: PropTypes.func,
  userName: PropTypes.string,
  auctionTitle: PropTypes.string,
  wonItemCount: PropTypes.number,
  lostItemCount: PropTypes.number,
  lostItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      item: PropTypes.string
    })
  )
}

export default AlertFinishedOutbid



// WEBPACK FOOTER //
// ./src/ui/alerts/alert-finished-outbid.js